import React, { Component } from 'react';
import { connect } from 'react-redux';
import { videoType } from '../../utils/shared';
import _ from 'lodash'

const _videoStyle = {
  preload: 'auto',
  position: 'relative',
  minWidth: '100%',
  minHeight: '100%',
  width: '100%',
  height: '100%',
  loop: '',
  autoplay: "",
  muted: "",
  pointerEvents: "none"
}

class QuoteStory extends Component {
  constructor(props) {
    super(props);

    try {
      this._element = this.props.element;
      this._horizontalScreens = _.get(this.props, 'horizontalScreens', 3);
      this._verticalScreens = _.get(this.props, 'verticalScreens', 2);
      this._fullscreen = _.get(this.props, 'fullscreen', false);

      this.state = {
        element: this.props.element,
        currentStage: this.props.stage
      }

    } catch(e) {
      console.log(e)
    }
  }

  componentDidMount() {
    // console.log("Mounted")
  }

  render() {
    try {
      if (!this.state.element) {
        return (
          <div>
            No element present in the props
          </div>
        );
      }
  
      let sectionWidth = this.props.screen.screenWidth / this._horizontalScreens;
      let sectionHeight = this.props.screen.screenHeight / this._verticalScreens;
      let fileType = this.state.element.backgroundType;
      let backgroundOffsetX = (this.state.element.bodyCopy.section === "right") ? 0 : sectionWidth;
      let quoteOffsetX = (this.state.element.bodyCopy.section === "right") ? sectionWidth * 2 : 0;
  
      let mediaStyle = {
        left: backgroundOffsetX,
        top: 0,
        width: sectionWidth * 2,
        maxWidth: sectionWidth * 2,
        height: this.props.screen.screenHeight
      }

      if (this._fullscreen) {
        mediaStyle.left = 0;
        mediaStyle.width = this.props.screen.screenWidth;
        mediaStyle.maxWidth = this.props.screen.screenWidth;
        mediaStyle.height = this.props.screen.screenHeight;
      }
  
      // Content (Media or Video)
      let content = "";
  
      if (fileType === "video") {
        let cType = videoType(this.state.element.backgroundImageDonorSea);
        content = (
          <div className="vid" style={{ position: 'absolute', top: 0, left: backgroundOffsetX, width: sectionWidth * 2, maxWidth: sectionWidth * 2 }}>
            <video style={_videoStyle} ref={el => this._currentVideoRef = el} id="background-video" loop autoPlay muted>
              <source src={this.state.element.backgroundImageDonorSea} type={cType} />
              Your browser does not support the video tag.
            </video>
          </div>);
      } else {
        content = (
          <div style={{ ...mediaStyle, position: 'absolute', backgroundSize: "cover", backgroundImage: "url(" + this.state.element.backgroundImageDonorSea + ")" }} />
        );
      }
  
      // QuoteArea
      let quoteArea = "";
      if (!this._fullscreen) {
        quoteArea = (
          <div style={{ backgroundColor: this.state.element.bodyCopy.quoteBackdrop, width: sectionWidth, height: sectionHeight * this._verticalScreens, left: quoteOffsetX, position: "fixed" }} />
        )
      }
  
      return (
        <div>
          {content}
          {quoteArea}
        </div>
      );

    } catch(e) {
      console.log(e)
    }
  }
}

const mapStateToProps = (state) => {
  return {
    screen: state.screen,
    content: state.content,
  };
};


export default connect(mapStateToProps)(QuoteStory);


// WEBPACK FOOTER //
// ./src/Components/Quote/QuoteStory.js